import { ProductDetail } from './product-card-detail.dto-response';

export class ProductCardDetailsDtoResponse {
  details: ProductDetail[];
  orientation: string;
}
